import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EntityProjectFilterComponent } from './entity-project-filter.component';
import { RoleUserPickerComponent } from './role-user-picker.component';

@NgModule({
  declarations: [EntityProjectFilterComponent, RoleUserPickerComponent],
  imports: [CommonModule, FormsModule],
  exports: [EntityProjectFilterComponent, RoleUserPickerComponent],
})
export class EntityLeadsSharedModule {}
